import { render, staticRenderFns } from "./FoodDistributionFamilyDetails.vue?vue&type=template&id=4fea4fe3&"
import script from "./FoodDistributionFamilyDetails.vue?vue&type=script&lang=js&"
export * from "./FoodDistributionFamilyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports